import { Util } from "../../shared/util";

export class RedirectService {
  public static CreateRedirectUrl(shortPath: string): string {
    return `${Util.GetCurrentUrlOrigin()}/r/${shortPath}`;
  }
}
